/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Table } from 'antd';
import moment from 'moment';
import React from 'react';
import theme from '../../../../../../../../assets/styles/theme/theme';
import { CustomTableCell } from '../../../../../../../../components/Commons/Tables/styles';
import {
  IFabricationMockupProject,
  IPavement
} from '../../../../../../../../store/ducks/fabrication-mockups/types';
import DownloadProjectColumn from '../../../../../Projects/ProjectsTable/ViewOptionsButton/DownloadProjectColumn';
import { PavementProjectsTableModal } from './styles';

interface IPavementProjectsTableDataSource {
  key: number;
  projectName: string;
  structures: string[];
  creationDate: string;
  revision: string;
  action: IFabricationMockupProject;
}

interface IPavementProjectsTableProps {
  pavement: IPavement;
  contractNumber: string;
  onCancel: () => void;
}

const PavementProjectsTable: React.FC<IPavementProjectsTableProps> = ({
  contractNumber,
  pavement,
  onCancel
}) => {
  const data: IPavementProjectsTableDataSource[] = pavement.projects!.map(
    (project, idx) => {
      return {
        key: idx,
        projectName: project.fileName,
        structures: project.structures.map((s) => s.name),
        creationDate: project.creationDate,
        revision: project.revision || ' - ',
        action: project
      };
    }
  );

  const pageSizeOptions =
    window.innerWidth <= Number(theme.breakpoints.tablet.replace('px', ''))
      ? ['5', '10', '20']
      : ['20', '30', '50'];

  const columns = [
    {
      width: '15%',
      title: 'Nome do projeto',
      dataIndex: 'projectName',
      sorter: (
        a: IPavementProjectsTableDataSource,
        b: IPavementProjectsTableDataSource
      ) => a.projectName.localeCompare(b.projectName),
      render: (text: string) => (
        <CustomTableCell>{text ? text : ' - '}</CustomTableCell>
      )
    },
    {
      width: '13%',
      title: 'Estrutura',
      dataIndex: 'structures',
      sorter: (
        a: IPavementProjectsTableDataSource,
        b: IPavementProjectsTableDataSource
      ) => a.structures.toString().localeCompare(b.structures.toString()),
      render: (structures: string[]) => (
        <CustomTableCell>
          {structures.length > 0
            ? structures.map((structure, idx) => (
                <p key={idx} className="structure">
                  {structure}
                </p>
              ))
            : ' - '}
        </CustomTableCell>
      )
    },
    {
      width: '5%',
      title: 'Revisão',
      dataIndex: 'revision',
      sorter: (
        a: IPavementProjectsTableDataSource,
        b: IPavementProjectsTableDataSource
      ) => a.revision.localeCompare(b.revision),
      render: (revision: string) => (
        <CustomTableCell>{revision ? revision : ' - '}</CustomTableCell>
      )
    },
    {
      width: '15%',
      title: 'Data de criação',
      dataIndex: 'creationDate',
      sorter: (
        a: IPavementProjectsTableDataSource,
        b: IPavementProjectsTableDataSource
      ) =>
        moment(a.creationDate).toDate().getTime() -
        moment(b.creationDate).toDate().getTime(),
      sortDirections: ['descend' as const],
      render: (creationDate: string) => (
        <CustomTableCell>
          {creationDate ? moment(creationDate).format('DD/MM/YYYY') : ' - '}
        </CustomTableCell>
      )
    },
    {
      width: '15%',
      title: 'Opções',
      dataIndex: 'action',
      render: (project: IFabricationMockupProject) => (
        <CustomTableCell>
          <DownloadProjectColumn
            contractNumber={contractNumber}
            projectId={project.id}
            fileName={project.fileName}
          />
        </CustomTableCell>
      )
    }
  ];

  return (
    <>
      <PavementProjectsTableModal
        width={956}
        visible={true}
        title={pavement.name + ' - Projetos'}
        onCancel={onCancel}
        footer={[]}
        closable={true}
      >
        <Table
          id="project-history-table"
          columns={columns}
          dataSource={data}
          pagination={{
            defaultPageSize: Number(pageSizeOptions[0]),
            pageSizeOptions: pageSizeOptions,
            showSizeChanger: true,
            responsive: true,
            hideOnSinglePage: true
          }}
          scroll={{
            x: 'max-content'
          }}
        />
      </PavementProjectsTableModal>
    </>
  );
};

export default PavementProjectsTable;
